import type { LogEntry } from "./boardbook-model";

/** Suggest a number from the immediately preceding leg, never skipping blank numbers. */
export function nextFlightNumber(entries: readonly LogEntry[], entry?: LogEntry): string {
  const time = (leg: LogEntry) => `${leg.date}T${leg.blockOff || leg.takeoff || "00:00"}`;
  const before = entry?.date ? time(entry) : "";
  const previous = entries
    .filter((leg) => leg.date && (!entry?.id || leg.id !== entry.id) && (!before || time(leg) < before))
    .reduce<LogEntry | undefined>((latest, leg) => (!latest || time(leg) > time(latest) ? leg : latest), undefined);
  const number = previous?.flightNumber?.trim() ?? "";
  if (!/^\d+$/.test(number)) return "";
  const next = Number(number) + 1;
  return Number.isSafeInteger(next) ? String(next).padStart(number.length, "0") : "";
}
